import * as React from 'react';
import { useSelector } from 'react-redux';
import { getInsurancesByGroups } from '../../../store/order/selectors';
import InsuranceUpsale from '../../../../CheckoutAdditionalService/components/InsuranceUpsale/InsuranceUpsale';
import InsuranceUpsaleAggregator from '../../../../CheckoutAdditionalService/components/InsuranceUpsale/InsuranceUpsaleAggregator';
import InsuranceV2 from '../../../../CheckoutAdditionalService/components/InsuranceUpsale/InsuranceUpsaleV2';
import { InsuranceType } from '@websky/graphql';
const OrderInsuranceBlockSlotUpsale = ({ aggregatorMode = false, cardV2Style }) => {
    const insurancesByGroups = useSelector(getInsurancesByGroups);
    let Insurance = InsuranceUpsale;
    if (aggregatorMode) {
        Insurance = InsuranceUpsaleAggregator;
    }
    if (cardV2Style) {
        Insurance = InsuranceV2;
    }
    return (React.createElement(React.Fragment, null, insurancesByGroups.map((insurances, index) => {
        const filteredInsurancePrograms = insurances.insurancePrograms.filter(program => {
            if (program.type === InsuranceType.Vsk) {
                return program.canBeAdded;
            }
            return true;
        });
        return (React.createElement(Insurance, { key: index, groupName: insurances.groupName, insurancePrograms: filteredInsurancePrograms, oldVersion: true }));
    })));
};
export default OrderInsuranceBlockSlotUpsale;
